

let mark = function () { }
let measure = function () { }
let open = function () { }
let start = function () { }
let end = function () { }
if (window?.performance) {
  var perf = window.performance;
  mark = function (tag) {
    if (window.dsfDebug) {
      return perf.mark(tag);
    }

  };
  measure = function (name, startTag, endTag) {
    if (window.dsfDebug) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
    }
  };
  start = function (flag) {
    mark(flag + " start");
  }
  end = function (flag) {
    mark(flag + " end");
    measure(flag, flag + " start", flag + " end");
  }
  open = function () {
    if (window.dsfDebug) {
      if (window.PerformanceObserver) {
        var pobserver = new PerformanceObserver((list) => {
          for (var entry of list.getEntries()) {
            var e = entry;
            let notPoint = false;
            //禁止vue相关输出
            if (e.name.startsWith("vue")) {
              notPoint = true;
            }
            //禁止ajax请求
            // if (e.initiatorType == "xmlhttprequest") {
            //   notPoint = true;
            // }
            if (!notPoint) {
              console.groupCollapsed(e.name);
              dsf.log(e.name)
              dsf.log(e.entryType);
              dsf.log("执行开始时间:" + e.startTime);
              dsf.log("执行花费时间:" + e.duration);
              console.groupEnd(e.name);
            }
          }
        })
        pobserver.observe({ entryTypes: ['longtask', 'frame', 'navigation', 'resource', 'mark', 'measure', 'paint'] });
      }
    }
  }
}



export default {
  start,
  end,
  open,
  mark,
  measure
}